// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","wrapper":"App_wrapper__nlASx"};